module.exports = __webpack_public_path__ + "static/media/clock_white.8f58f742.svg";